import { api } from './api';

export enum Platform {
  IOS = 0,
  ANDROID = 1,
}

export interface AppVersionConfigEntity {
  id: string;
  platform: Platform;
  latestVersion: string | null;
  minimumVersion: string | null;
  storeUrl: string | null;
  releaseNotes: string | null;
  enabled: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface UpsertAppVersionConfigDto {
  platform: Platform;
  latestVersion?: string;
  minimumVersion?: string;
  storeUrl?: string;
  releaseNotes?: string;
  enabled?: boolean;
}

export const appVersionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAppVersionConfigs: builder.query<AppVersionConfigEntity[], void>({
      query: () => ({
        url: '/app-config/admin/version',
        method: 'GET',
      }),
      providesTags: ['AppVersionConfig'],
    }),
    upsertAppVersionConfig: builder.mutation<
      AppVersionConfigEntity,
      UpsertAppVersionConfigDto
    >({
      query: ({ platform, ...body }) => ({
        url: `/app-config/admin/version/${platform}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AppVersionConfig'],
    }),
  }),
});

export const {
  useGetAppVersionConfigsQuery,
  useUpsertAppVersionConfigMutation,
} = appVersionApi;
